<template>
  <transition
    appear
    class="tw:block tw:md:hidden tw:fixed tw:w-full tw:overflow-y-auto tw:z-20 tw-card tw:shadow-lg tw:pb-1"
    :class="{'tw:bg-gray-50': !isSicuraSolution,
             'tw:bg-[#f8f3ee75]': isSicuraSolution,
    }"

    style="max-height: 400px; width: calc(100vw - 10px); left: 4px; bottom: 4px"
    enter-active-class="animate__animated animate__slideInUp animate__faster"
    leave-active-class="animate__animated animate__slideOutDown animate__faster"
  >
    <div
      v-if="show && $slots['sidebar']"
      v-click-outside="
        () => {
          show = false;
        }
      "
    >
      <div
        class="tw:flex tw:justify-end"
        :class="{'tw:bg-gray-50': !isSicuraSolution,
                 'tw:bg-[#f8f3ee75]': isSicuraSolution,
        }"
      >
        <button
          @click="
            () => {
              show = false;
            }
          "
        >
          <i class="fas fa-times tw:text-gray-500" style="font-size: 24px" />
        </button>
      </div>
      <slot name="sidebar" />
    </div>
  </transition>

  <div class="tw:h-full tw:grid baseGrid">
    <div
      class="tw:hidden tw:md:block tw:h-full tw:overflow-y-auto"
      :class="{
        'tw:p-4 tw:pr-0': !$route.fullPath.includes('/private/launcher') && !$route.fullPath.includes('/private/notifications-center'),
        'tw:bg-gray-50': !isSicuraSolution,
        'tw:bg-[#f8f3ee75]': isSicuraSolution,
      }"
    >
      <slot name="sidebar" />
    </div>

    <div
      :class="{
        'tw:overflow-y-auto': $route.fullPath.includes('/private/notifications-center'),
        'tw:overflow-y-auto tw:p-4': !$route.fullPath.includes('/private/notifications-center'),
        'tw:bg-gray-50': !isSicuraSolution,
        'tw:bg-[#f8f3ee75]': isSicuraSolution,
      }"
    >
      <slot />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useSidebar } from '@/composables/useSidebar';
import { useBrand } from '@/composables/useBrand';

export default defineComponent({
  setup() {
    const { show } = useSidebar();
    const { isSicuraSolution } = useBrand();

    return {
      show,
      isSicuraSolution,
    };
  },
});
</script>
<style>
.baseGrid {
  grid-template-columns: 1fr;
}

@media (min-width: 820px) {
  .baseGrid {
    grid-template-columns: minmax(0, 300px) minmax(0, 1fr);
  }
}
</style>
